import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import Parser from 'html-react-parser';
import {
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIintegrationCallMethod } from '../api/Integrations';

import ErrorBoundary from './ErrorBoundary';
import Loading from './Loading';

const G2ReviewModal = ({ handleClose }) => {
  const [embedUrl, setEmbedUrl] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    APIintegrationCallMethod('g2', 'getEmbedUrl').then((response) => {
      if (response.embed_url) {
        setEmbedUrl(response.embed_url);
      }
    });
  }, []);

  return (
    <ErrorBoundary>
      <ModalHeader toggle={handleClose}>
        {intl.formatMessage({ defaultMessage: 'Leave review' })}
      </ModalHeader>
      <ModalBody>
        {!embedUrl ? (
          <Loading />
        ) : (
          <iframe title="G2 Review" src={embedUrl} />
        )}
      </ModalBody>
    </ErrorBoundary>
  );
};

G2ReviewModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default G2ReviewModal;
